module.exports = __webpack_public_path__ + "static/media/em-117.239e578e.png";